import { DeliveryContainerHistoricalContentsDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Delivery } from '../../deliveries/models/delivery.model';

export class DeliveryContainerHistoricalContentsModel {
  isMasked: boolean;
  delivery?: Delivery;
  maskedDelivery?: MaskedDelivery;

  constructor(dto: DeliveryContainerHistoricalContentsDto) {
    this.isMasked = dto.isMasked;
    if (dto.isMasked && dto.maskedDelivery) {
      this.maskedDelivery = new MaskedDelivery(dto.maskedDelivery.deliveryReference);
    }
    if (!dto.isMasked && dto.delivery) {
      this.delivery = new Delivery(dto.delivery);
    }
  }
}

export class MaskedDelivery {
  deliveryReference: string;

  constructor(deliveryReference: string) {
    this.deliveryReference = deliveryReference;
  }
}
